import has from "has";
import makePageDefinitions from "./menu_page_entries";

export default function MenuContentService(
    APP_CATEGORY,
    VERSION,
    SABLONO_STATES,
    $sbFeatureDecisions,
    EnvironmentFlags,
    PageFlags
) {
    "ngInject";

    const pages = makePageDefinitions(SABLONO_STATES, APP_CATEGORY);

    function pickPageByFeature(flag, pageEnabled, pageDisabled) {
        return $sbFeatureDecisions.isFeatureEnabled(flag)
            ? pageEnabled
            : pageDisabled;
    }

    function processViewer() {
        if (
            $sbFeatureDecisions.isFeatureEnabled(
                EnvironmentFlags.DeprecatedFeatureToRemoveSoon
            )
        ) {
            return [pages.processViewer];
        }
        return [];
    }

    function performanceDashboard() {
        if (
            $sbFeatureDecisions.isFeatureEnabled(
                PageFlags.PerformanceDashboardPro
            )
        ) {
            return [pages.dashboardPro];
        }

        return [];
    }

    function qaChecklistTemplate() {
        return [
            pickPageByFeature(
                PageFlags.RequestAccessQAChecklists,
                pages.requestAccessQAChecklists,
                pages.checklistTemplatesList
            ),
        ];
    }

    function commercialFeatures() {
        return [
            pickPageByFeature(
                PageFlags.CommercialValuation,
                pages.commercialProDashboard,
                pages.requestAccessCommercialProDashboard
            ),
        ];
    }

    function generateMenu() {
        const sections = [
            {
                name: "SECTION_SIDENAV_PROJECT_OVERVIEW_TITLE",
                type: "toggle",
                classes: "",
                cyName: "menu-project-overview",
                pages: [
                    pickPageByFeature(
                        PageFlags.VisualTrackers,
                        pages.visualization,
                        pages.requestAccessVisualTrackers
                    ),
                    ...performanceDashboard(),
                    pages.packageTracker,
                    pages.inspections,
                    ...processViewer(),
                ],
            },
            {
                name: "SECTION_SIDENAV_QUALITY_AND_COMPLIANCE_TITLE",
                type: "toggle",
                classes: "",
                cyName: "menu-quality-and-compliance",
                pages: [
                    pages.tracker,
                    pickPageByFeature(
                        PageFlags.Notes,
                        pages.issues,
                        pages.requestAccessNotes
                    ),
                    pickPageByFeature(
                        PageFlags.Deliverables,
                        pages.deliverablesProgress,
                        pages.requestAccessDeliverables
                    ),
                ],
            },
            {
                name: "SECTION_SIDENAV_EXECUTION_TITLE",
                type: "toggle",
                classes: "",
                cyName: "menu-execution",
                pages: [
                    pickPageByFeature(
                        PageFlags.LeanPlanning,
                        pages.leanboard,
                        pages.requestAccessLeanPlanning
                    ),
                    pages.siteDiary,
                    ...commercialFeatures(),
                ],
            },
            {
                name: "SECTION_SIDENAV_CONFIGURATION_TITLE",
                type: "toggle",
                classes: "tour-setup-menu-btn",
                cyName: "setup",
                pages: [
                    pages.templates,
                    ...qaChecklistTemplate(),
                    pages.noteTemplates,
                    pages.teams,
                    pages.wbs,
                    pages.projectSettings,
                ],
            },
            {
                name: "SECTION_SIDENAV_RESOURCES_TITLE",
                type: "toggle",
                classes: "",
                cyName: "resources",
                pages: [
                    pages.faq,
                    pages.versionPage,
                    pages.ideasPortal,
                    pages.imprint,
                    pages.eula,
                    pages.privacyPolicy,
                ],
            },
        ];

        if (has("development")) {
            sections[4].pages.push({
                name: "Version " + VERSION,
                state: "sablono.info",
                type: "state",
                icon: "mdi mdi-ticket",
                highlight: "sablono.info",
            });
        }

        return {
            header: [
                {
                    ...pages.projectSelection,
                    cyName: "menu-show-my-projects",
                },
                pages.myWork,
            ],
            headerNoProject: [pages.projectSelection],
            sections: sections,
        };
    }

    return { generateMenu };
}
